import React from 'react';

export default function TableNotFound({ Icon, title }: any) {
  return (
    <div
      style={{
        width: '100%',
        height: '20rem',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 20,
      }}
    >
      <Icon style={{ fontSize: '5rem' }} />
      <h6>{title}</h6>
    </div>
  );
}
